export const recaptchaConsts = {  
Url : "https://www.google.com/recaptcha/api.js?onload={0}onloadCallback&render=explicit&hl={1}"
};